<template>
    <div class="col-sm-12">
        <div class="form-group">
            <span class="filter-icon"><i class="fa fa-sort-numeric-desc"></i></span>

            <label for="searchByColumn">
                <select id="searchByColumn"
                        class="form-control input-sm"
                        v-model="searchableColumn">
                    <option value disabled>- Choose a column -</option>
                    <option v-for="column in columns"
                            :key="column.idx" :value="column.prop">{{$t(`messages.${column.title}`)}}
                    </option>
                </select>
            </label>

            <span class="nowrap">
            <select id="operator"
                    class="form-control input-sm"
                    v-model="selectedOperator">
                <option v-for="operator in operators" :selected="operator.value===selectedOperator"
                        :key="operator.name" :value="operator.value" v-html="operator.name">
                </option>
            </select>

            <input type="text"
                   id="searchValue"
                   class="form-control input-sm"
                   v-model="searchValue"
                   style="transform: translateY(1px)">
            </span>
        </div>
    </div>
</template>

<script>
  export default {
    props: {
      /**
       * An array of objects having following structure:
       * {title: colTitle, idx: columnIndex}
       */
      columns: {
        type: Array,
        required: true
      },
      loading: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        searchableColumn: null,
        searchValue: null,
        operators: [
          {name: '&lt;', value: 'lt'},
          {name: '&gt;', value: 'gt'},
          {name: '&lt;=', value: 'lte'},
          {name: '&gt;=', value: 'gte'},
          {name: '=', value: 'e'}
        ],
        selectedOperator: 'e'
      }
    },
    computed: {
      /**
       * Query parameter for AJAX call
       * @return {{}}
       */
      q () {
        let q = {}

        if (this.searchableColumn && this.searchValue) {
          const val = encodeURIComponent(this.searchValue)
          this.selectedOperator !== 'e'
            ? q[this.searchableColumn] = {[this.selectedOperator]: val}
            : q[this.searchableColumn] = val
        }

        return q
      }
    },
    methods: {
      getQuery () {
        return this.q
      },
      reset () {
        this.searchableColumn = null
        this.searchValue = null
        this.selectedOperator = {name: '=', value: null}
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/components/datatables/NumericFilter.vue